import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class SolicitacaoProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;
  totalAdm: any = 0;
  constructor(public http: HttpClient) {}

  getSolicitacoes(pag, meusPedidos) {
    return this.http
      .get<any>(this.baseUrl + '/solicitacao', {
        observe: 'response',
        params: {
          expand: 'total, userOrei',
          page: pag.currentPage,
          'per-page': '10',
          meusPedidos: meusPedidos,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
          totalPendente: data.headers.get('X-Count-Pedido-Oracao-Pendente'),
        };

        return {
          oracoes: data.body,
          pagination: pag,
        };
      });
  }

  getAdmSolicitacoes(pag, filtro) {
    return this.http
      .post<any>(this.baseUrl + '/solicitacao/adm-list', filtro, {
        observe: 'response',
        params: {
          expand: 'status,liberado,privacidade,idPessoa',
          page: pag.currentPage,
          'per-page': '5',
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          oracoes: data.body,
          pagination: pag,
        };
      });
  }

  oreiPorVoce(solicitacao) {
    return this.http.post<any>(this.baseUrl + '/solicitacao/orei-por-voce', solicitacao).map((data) => {
      if (!data.error) {
        //this.getInicioOracaoAdmin().subscribe();
        return data;
      } else {
        return false;
      }
    });
  }

  getResposta(id) {
    return this.http
      .get<any>(this.baseUrl + '/solicitacao/resposta', {
        params: {
          id: id,
        },
      })
      .map((data) => {
        if (!data.error) {
          return data.resposta;
        } else {
          return false;
        }
      });
  }

  getAdminTotal() {
    return this.totalAdm;
  }

  getInicioOracaoAdmin() {
    return 0;
    // return this.http.get<any>(this.baseUrl + '/oracao/get-nao-orados', {
    // })
    //   .map(data => {
    //     if (!data.error) {
    //       this.totalAdm = data;
    //       return data;
    //     } else {
    //       return false;
    //     }
    //   });
  }

  getPessoaOrando(id) {
    return this.http
      .get<any>(this.baseUrl + '/solicitacao/pessoas-orando', {
        params: {
          id: id,
        },
      })
      .map((data) => {
        if (!data.error) {
          return data.pessoas;
        } else {
          return false;
        }
      });
  }

  denunciar(solicitacao) {
    return this.http.post<any>(this.baseUrl + '/solicitacao/denunciar', solicitacao).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  excluir(id) {
    return this.http.post<any>(this.baseUrl + '/solicitacao/excluir', { id: id }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  criarSolicitacao(pedido, publico = false) {
    return this.http
      .post<any>(this.baseUrl + '/solicitacao', {
        pedido: pedido,
        publico: publico,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  setPublico(id, publico) {
    return this.http
      .post<any>(this.baseUrl + '/solicitacao/set-liberado', {
        id: id,
        liberado: publico,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  responder(id, liberado, resposta) {
    return this.http
      .post<any>(this.baseUrl + '/solicitacao/enviar-resposta', {
        id: id,
        liberado: liberado,
        resposta: resposta,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/solicitacao/solicitacao.ts